import * as React from 'react'
import { useState } from 'react'
import PartnerPicker from './PartnerPicker'
import { PartnerShape } from '../../api/api_data_types'
import RemoveFieldsButton from '../shared/RemoveFieldsButton'
import PartnerRecordTimesTable from './PartnerRecordTimesTable'
import PartnerRecordTimesForm from './PartnerRecordTimesForm'
import uuid from 'uuid/v4'
import RemovedField from "./RemovedField";

type PartnerRecordFieldsProps = {
  partnerFields: {
    id: number
    _destroy?: boolean
    times_attributes: {
      [key: string]: {
        id?: number
        time: number
        worktype_id: number
        comment: string
        partner_time: boolean
      }
    }
    partner_id?: number
  }
  setPartnerFields: (partnerFields: any) => void
  availablePartners: PartnerShape[]
  allPartners: PartnerShape[]
  availableWorktypes: [string, number][]
  fieldNameFn: (field: string) => string
  handleRemove: () => void
  className?: string
  allowRemove?: boolean
  disabled?: boolean
}

export default function PartnerRecordFields(props: PartnerRecordFieldsProps) {
  const {
    partnerFields,
    setPartnerFields,
    availablePartners,
    allPartners,
    availableWorktypes,
    handleRemove,
    fieldNameFn,
    className = '',
    allowRemove = true,
    disabled = false,
  } = props

  const [isEditing, setIsEditing] = useState(false)

  // const partnerId = partnerFields.partner_id || null
  if (partnerFields._destroy === true) {
    return (
      <>
        <RemovedField field={partnerFields} fieldNameFn={fieldNameFn} />
        {/*{partnerId && <input type="hidden" name={fieldNameFn('partner_id')} value={partnerId} />}*/}
      </>
    )
  }

  return (
    <fieldset className={`position-relative form-fieldset ${className}`}>
      <div className="row">
        <div className="col-12">
          <PartnerPicker
            partnerId={partnerFields.partner_id || null}
            setPartnerId={id => setPartnerFields({ ...partnerFields, partner_id: id })}
            availablePartners={availablePartners}
            allPartners={allPartners}
            name={fieldNameFn('partner_id')}
            disabled={disabled || !!partnerFields.id}
          />
          {partnerFields.id && <input type="hidden" name={fieldNameFn('id')} value={partnerFields.id} />}
          {partnerFields.id && <input type="hidden" name={fieldNameFn('partner_id')} value={partnerFields.partner_id} />}
        </div>
      </div>

      <div className="d-flex justify-content-end">
        {!isEditing && (
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setIsEditing(true)}>
            Rediger tids
          </button>
        )}
        {isEditing && (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => {
              setPartnerFields({
                ...partnerFields,
                times_attributes: {
                  ...partnerFields.times_attributes,
                  [uuid()]: {
                    time: 0,
                    worktype_id: availableWorktypes[0][1],
                    comment: '',
                  },
                },
              })
            }}
          >
            + Tilføj tid
          </button>
        )}
      </div>
      <div className="row mt-3">
        <div className="col-12">
          {isEditing ? (
            <PartnerRecordTimesForm
              fieldNameFn={fieldNameFn}
              partnerFields={partnerFields}
              setPartnerFields={setPartnerFields}
              availableWorktypes={availableWorktypes}
              availablePartners={availablePartners}
              allPartners={allPartners}
            />
          ) : (
            <PartnerRecordTimesTable
              times={partnerFields.times_attributes}
              availableWorktypes={availableWorktypes}
              fieldNameFn={fieldNameFn}
            />
          )}
        </div>
      </div>
      {allowRemove && !disabled && <RemoveFieldsButton className="resources-remove-fields-button" handleRemove={handleRemove} />}
    </fieldset>
  )
}
